<div class="process-status">
  <h3>Processing</h3>
  <div class="spinner-container">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
  </div>
  <div class="status-message">{{ statusText }}</div>
  <div class="actions" *ngIf="!polling">
    <button mat-button (click)="close(true)">Close</button>
  </div>
</div>
